import { useContext } from "react";
import { useConvexUser } from "./useConvexUser";
import { useLocalStorageImage } from "./useLocalStorageImage";
import { useStableQuery } from "./useStableQuery";
import { api } from "../../convex/_generated/api";
import { Id } from "../../convex/_generated/dataModel";
import { BaseContext } from "../base-context";

export const useProfileImage = () => {
    const { user } = useConvexUser();
    const { convexUserId } = useContext(BaseContext);
    
    // Get user metadata for nickname
    const userMetadata = useStableQuery(
        api.user_metadata.getUserMetadata,
        convexUserId ? { user_id: convexUserId as Id<"users"> } : "skip"
    );
    
    // Use nickname from user_metadata, then first name from legal_name, then Clerk name
    const displayName = userMetadata?.nickname || userMetadata?.legal_name?.split(' ')[0] || user?.fullName || "User";
    
    const profileImage = useLocalStorageImage({
        url: user?.imageUrl || '',
        alt: `${displayName}'s profile picture`,
        className: "w-10 h-10 sm:w-14 sm:h-14 flex-shrink-0 rounded-full border-primary-3 border-4 object-cover"
    });

    return profileImage;
}